var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import { FlashList } from '@shopify/flash-list';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ScreenLayout } from '@/components/ScreenLayout';
import useAppComponents from '@/hooks/useAppComponents';
import ConqueredPlaceItem from '@/screens/ConquererHistoryScreen/sections/ConqueredPlaceItem';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import React from 'react';
import { View } from 'react-native';
import AchievementsSection from './sections/AchievementsSection';
export default function ConquererHistoryScreen() {
    var _a;
    const insets = useSafeAreaInsets();
    const { api } = useAppComponents();
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['ConqueredPlaces'],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam }) {
            return (yield api.listConqueredPlacesPost({
                nextToken: pageParam,
                limit: 20,
            })).data;
        }),
        getNextPageParam: lastPage => {
            return lastPage.nextToken;
        },
        initialPageParam: undefined,
    });
    const places = data === null || data === void 0 ? void 0 : data.pages.flatMap(page => { var _a; return (_a = page.items) !== null && _a !== void 0 ? _a : []; });
    return (_jsx(ScreenLayout, { isHeaderVisible: true, children: _jsx(View, { className: "flex-1", children: _jsx(FlashList, { contentContainerStyle: {
                    backgroundColor: 'white',
                    paddingBottom: insets.bottom,
                }, ListHeaderComponent: _jsx(AchievementsSection, { totalNumberOfPlaces: (_a = data === null || data === void 0 ? void 0 : data.pages[0].totalNumberOfItems) !== null && _a !== void 0 ? _a : 0 }), data: places, renderItem: ({ item }) => _jsx(ConqueredPlaceItem, { p: item }), estimatedItemSize: 50, onEndReached: () => {
                    if (hasNextPage && !isFetchingNextPage) {
                        fetchNextPage();
                    }
                }, onEndReachedThreshold: 0.5 }) }) }));
}
